<template>
    <div class="content">
        <h1>WILLKOMMEN</h1>
        <div class="home-content">
            <p>
                Hier können Sie alles Wesentliche über meinen beruflichen Werdegang erfahren.
            </p>
            <p>
                Über das Menü können Sie die verschiedenen Bereiche meines Werdens durchforsten und
                sich einen Überblick verschaffen, wer ich bin, was ich kann, und was ich mache.
            </p>
            <p>
                Klicken Sie sich einfach durch, und lernen Sie mich kennen.
            </p>
            <img :src="personaImg" class="persona-img" />
            <h2>Meine persönlichen Daten</h2>
            <p>
                Guido Buchholz
            </p>
            <p>
                11.07.1967 - Aachen - Deutschland
            </p>
            <p>
                geschieden, 5 Kinder
            </p>
            <p>
                deutsche Staatsangehörigkeit
            </p>
        </div>
    </div>
</template>

<script>
import siteConfig from '@/assets/js/mixins/siteConfig';

export default {
    name: 'Home',
    mixins: [
        siteConfig
    ],
    data() {
        return {
            // personaImg: siteConfig.imgUrl + 'gb_2020_01_800x460.jpg'
            personaImg: siteConfig.imgUrl + 'gb_2020-07-18_650x800.jpg'
        };
    },
    methods: {
        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        }
    },
    mounted() {
        this.emitLogData('home', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('home', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    .home-content {
        margin-top: 15px;
    }
    .fas {
        margin-right: 10px;
    }
    .persona-img {
        margin: 10px 0 20px 0;
        max-width: 400px;
    }
</style>
